import { renderDashboard } from "./pages/dashboard.js";
import { renderPerformance } from "./pages/performance.js";
import { renderTrades } from "./pages/trades.js";
import { renderDailySummary } from "./pages/daily-summary.js";
import { renderStats } from "./pages/stats.js";
import { renderWatchlist } from "./pages/watchlist.js";
import { renderAccount } from "./pages/account.js";
import { renderLoginHistory } from "./pages/login-history.js";
import { renderUsers } from "./pages/users.js";

export type PageRenderer = (container: HTMLElement) => Promise<void> | void;

// 002 §7: 화면5(설정변경)는 Phase2 — 라우트 자체를 등록하지 않는다.
export const ROUTES: Record<string, PageRenderer> = {
  "#/dashboard": renderDashboard,
  "#/performance": renderPerformance,
  "#/trades": renderTrades,
  "#/daily-summary": renderDailySummary,
  "#/stats": renderStats,
  "#/watchlist": renderWatchlist,
  "#/users": renderUsers,
  "#/account": renderAccount,
  "#/login-history": renderLoginHistory,
};

export const DEFAULT_ROUTE = "#/dashboard";

export function resolveRoute(hash: string): { hash: string; renderer: PageRenderer } {
  if (ROUTES[hash]) return { hash, renderer: ROUTES[hash] };
  return { hash: DEFAULT_ROUTE, renderer: ROUTES[DEFAULT_ROUTE]! };
}
